module.exports = __webpack_public_path__ + "img/lang.850216f5.png";